import { createUseStyles } from "react-jss";
import { ITheme } from "../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    overflowY: "scroll",
    overflowX: "hidden",
    scrollSnapType: "y mandatory",
    background: theme.colors.Background8,
    minHeight: "100vh",
    "-ms-overflow-style": "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */,
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  profileStat: {
    display: "flex",
    padding: theme.spacing.space16,
    flexDirection: "column",
    gap: theme.spacing.space16,
  },
  profileAchievement: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(128px, 1fr))",
    gap: theme.spacing.space8,
    padding: theme.spacing.space16,
  },
  achievementTitle: {
    padding: `${theme.spacing.space16}px ${theme.spacing.space16}px 0`,
  },
  card: {
    borderRadius: 8,
    background: `#222`,
    padding: `16px 12px`,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  cardLeft: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
}));
